// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  theme: 'prod-theme',
  // API_ENDPOINT: 'https://wscompra.plusfresc.cat/api/',
  // BASE_IMAGE_URL : 'https://compra.plusfresc.cat',
  API_ENDPOINT: 'https://twscompra.plusfresc.cat/api/',         // BASE URL SUPSA SERVICES
  BASE_IMAGE_URL : 'http://tcomp.plusfresc.cat',           // BASE URL SUPSA IMAGES
  MAX_ERROR_COUNT : 1,
  FAKE_DELAY: 250,
  MESSAGES_TIMEOUT: 5000,
  UPDATE_QTY_TIMEOUT: 1000,
  CHECK_TIMEOUT: 500,
  READY_TIMEOUT: 750,
  JWT : {
    REFRESH_TOKEN_MAX_REQUEST_COUNT : 500,
    REFRESH_TOKEN_EXPIRY_MINUTES: 5,
  },
  PAGE_SCROLL_DELAY : 200,
  MAX_RETRY_COUNT : 5,
  RETRY_DELAY : 5000,
  RESPONSIVE_SIZE: 991.98,
  CATALOG : {
    HOME_PAGE_SIZE : 10,
    PAGE_SIZE : 8
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
